import React, { useEffect, useState } from "react";
import { GENDER } from "../../utils/constants";
import Select from "react-select";
import { addBasicDataValidation } from "../../utils/validation";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BasicDetailForm = ({ nextStep, handleChange, formData }) => {
  const [selectGender, setSelectGender] = useState(formData.gender || null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const requiredFields = [
    "name",
    "email",
    "mobile",
    "whatsapp",
    "address",
    "location",
    "pincode",
    "gender",
    "password",
  ];

  const notifyError = (error) => toast.error(error);

  const validationError = addBasicDataValidation(
    formData.name,
    formData.email,
    formData.mobile,
    formData.whatsapp,
    formData.address,
    formData.location,
    formData.pincode,
    formData.password
  );

  const validateForm = () => {
    return requiredFields.every((field) => {
      const value = formData[field];
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      return value !== null && value !== undefined;
    });
  };

  useEffect(() => {
    setIsButtonDisabled(!validateForm());
  }, [formData]);

  const handleNextClick = () => {
    if (!validationError) {
      nextStep();
    } else {
      notifyError(validationError);
    }
  };

  const genderChangeHandler = (selectedValue) => {
    setSelectGender(selectedValue);
    handleChange({
      target: { name: "gender", value: selectedValue },
    });
  };

  return (
    <form>
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              id="name"
              placeholder="Enter Name*"
              value={formData.name || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="gender" className="form-label">
              Gender
            </label>
            <Select
              value={selectGender}
              onChange={genderChangeHandler}
              options={GENDER}
              name="gender"
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: "#e3f3f6",
                  primary: "#e3f3f6",
                },
              })}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  minHeight: "35px",
                  height: "35px",
                  borderColor: "#dee2e6",
                  "&:hover": {
                    borderColor: "#dee2e6",
                  },
                }),
                valueContainer: (baseStyles) => ({
                  ...baseStyles,
                  padding: "2px 8px",
                }),
                input: (baseStyles) => ({
                  ...baseStyles,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (baseStyles) => ({
                  ...baseStyles,
                  height: "35px",
                }),
                dropdownIndicator: (baseStyles) => ({
                  ...baseStyles,
                  padding: "4px",
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  color: "black",
                }),
                singleValue: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: "12px",
                }),
              }}
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              name="email"
              id="email"
              placeholder="Enter Email*"
              value={formData.email || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="mobile" className="form-label">
              Mobile Number
            </label>
            <input
              type="text"
              className="form-control"
              name="mobile"
              id="mobile"
              placeholder="Enter Mobile No.*"
              value={formData.mobile || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="whatsapp" className="form-label">
              Whatsapp Number
            </label>
            <input
              type="text"
              className="form-control"
              name="whatsapp"
              id="whatsapp"
              placeholder="Enter Whatsapp No.*"
              value={formData.whatsapp || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="whatsapp" className="form-label">
              Create Password
            </label>
            <input
              type="text"
              className="form-control"
              name="password"
              id="password"
              placeholder="Enter Password*"
              value={formData.password || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexCheckDefault"
            onChange={(e) => {
              if (e.target.checked) {
                handleChange({
                  target: { name: "whatsapp", value: formData.mobile },
                });
              } else {
                handleChange({
                  target: { name: "whatsapp", value: "" },
                });
              }
            }}
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            Click if Whatsapp and mobile number are the same.
          </label>
        </div>
        <div className="col-md-12 mt-3">
          <div className="mb-3">
            <label htmlFor="address" className="form-label">
              Address
            </label>
            <input
              type="text"
              className="form-control"
              name="address"
              id="address"
              placeholder="Enter Address*"
              value={formData.address || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="location" className="form-label">
              Location
            </label>
            <input
              type="text"
              className="form-control"
              name="location"
              id="location"
              placeholder="Enter Location*"
              value={formData.location || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="mb-3">
            <label htmlFor="pincode" className="form-label">
              Pincode
            </label>
            <input
              type="text"
              className="form-control"
              name="pincode"
              id="pincode"
              placeholder="Enter Pincode*"
              value={formData.pincode || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </div>
      <button
        type="button"
        className="nextBtn mt-3"
        onClick={handleNextClick}
        disabled={isButtonDisabled}
      >
        Next
      </button>
    </form>
  );
};

export default BasicDetailForm;
